import { firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'

const getUserProfileVerifierIds = async ({ uid }) => {
	try {
		const userProfileDocRef = firestore.collection('userProfiles').doc(uid)

		// TODO: deletes - these subcollection queries need to be handled, do we just remove the collection (put it under deleted too)? rename it?
		const verifiersQuerySnap = await userProfileDocRef.collection('verifiers').get()

		return verifiersQuerySnap.docs.map(d => d.id)
	} catch (error) {
		throw errorOfType(errorTypes.UNKNOWNERROR, uid, error)
	}
}

export default getUserProfileVerifierIds



// WEBPACK FOOTER //
// ./src/dataservices/getUserProfileVerifierIds.js